<div class="interface-for-all-container">
  <h2 class="interface-for-all-title">{{ 'interface.title' | translate }}</h2>
  <p class="interface-for-all-description">{{ 'interface.description' | translate }}</p>
  <div class="channels-list">
    <span class="channel">{{'olx.title' | translate }}</span>
    <span class="channel">{{'telegram.title' | translate }}</span>
    <span class="channel">{{'viber.title' | translate }}</span>
    <span class="channel">{{'instagram.title' | translate }}</span>
    <span class="channel">{{'auto-ria.title' | translate }}</span>
    <span class="channel">{{'dim-ria.title' | translate }}</span>
    <span class="channel">{{'agro-ria.title' | translate }}</span>
    <span class="channel">{{'prom.title' | translate }}</span>
    <span class="channel">{{'whatsapp.title' | translate }}</span>
  </div>
</div>
